import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Card } from "@mui/material";
import logo from "../../../../assets/eCarehealth-Logo.svg";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import Flex from "../../../../components/Flex";
import Text from "../../../../components/Text";

interface BirthDateFieldProps {
  birthDate?: any;
  setBirthDate: any;
  label?: string;
  onVerify: any;
}

/**
 *
 * @description This component is used to verify the birth date of the patient
 *
 * @param birthDate - The birth date of the patient
 * @param setBirthDate - The function to set the birth date
 * @param onVerify - The function to verify the birth date
 *
 * @author [Rajkumar Rathod]
 */
export const ValidateDob = ({
  birthDate,
  setBirthDate,
  onVerify,
}: BirthDateFieldProps) => {
  // const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        background: "white",
        // background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main} 100%)`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 2, sm: 4 },
        position: "relative",
      }}
    >
      <Card
        sx={{
          width: { xs: "90vw", sm: "450px" },
          maxWidth: "500px",
          padding: { xs: 3, sm: 4 },
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
        }}
        elevation={5}
      >
        <Flex flexDirection={"column"} gap={2.5} alignItems={"center"}>
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={logo} alt="Company Logo" style={{ height: "46px" }} />
          </Box>

          {/* Lock Icon */}
          <Flex alignItems={"center"} flexDirection={"column"}>
            <LockOutlinedIcon sx={{ fontSize: 48 }} color="primary" />

            {/* Title */}
            <Text fontWeight={"bold"} fontSize={"24px"}>
              Patient Verification
            </Text>
          </Flex>
          {/* Subtitle */}
          <Text
            fontSize={"14px"}
            sx={{
              textAlign: "center",
              color: "#6B7280",
              marginBottom: 1,
            }}
          >
            Please verify your identity to access your electronic health
            records.
          </Text>

          {/* Date of Birth Field */}
          <Box sx={{ width: "100%", marginTop: 2 }}>
            <Text
              fontSize={"14px"}
              fontWeight={"medium"}
              sx={{ marginBottom: 1, color: "#1F2937" }}
            >
              Date of Birth
            </Text>
            <CustomDatePicker
              value={birthDate}
              label=""
              onChange={(val) => setBirthDate(val)}
              slotProps={{
                textField: {
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: "white",
                    },
                  },
                },
                inputAdornment: {
                  position: "start",
                },
              }}
            />
          </Box>

          {/* Verify Button */}
          <Button
            disabled={!birthDate}
            variant="contained"
            onClick={() => onVerify()}
            fullWidth
            sx={{
              padding: "12px 24px",
              fontSize: "16px",
            }}
          >
            Verify Identity
          </Button>

          {/* Privacy Information */}
          <Flex
            alignItems={"center"}
            gap={1}
            sx={{ marginTop: 2, width: "100%" }}
          >
            <Box
              sx={{
                color: "#F59E0B",
                display: "flex",
                alignItems: "center",
              }}
            >
              <LockOutlinedIcon sx={{ fontSize: 16 }} />
            </Box>
            <Text fontSize={"12px"} sx={{ color: "#6B7280", lineHeight: 1.5 }}>
              Your privacy is protected. This information is used solely for
              identity verification in compliance with <b>HIPAA</b> regulations.
            </Text>
          </Flex>
        </Flex>
      </Card>
    </Box>
  );
};
